<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Access Module</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (accessSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Access:</span>
            <select
              class="halfWidthInputField"
              #accessInput
              [class.invalidConfigurationSelection]="isInvalidSelection(accessSelection.Name)"
              (change)="selectionChanged(accessSelection, accessInput.value)"
              [value]="accessSelection.Value.toString()">
              @for (allowable of accessSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="accessSelection.Value && accessSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (secondaryAccessSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(secondaryAccessSelection.Name)" for="secondaryAccessInput" class="halfWidthInputLabel">
              Secondary Access:
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="secondaryAccessInput"
              #secondaryAccessInput
              [checked]="'true' === secondaryAccessSelection.Value"
              (change)="selectionChanged(secondaryAccessSelection, secondaryAccessInput.checked.toString())" />
          </span>
        }
      </div>
    </div>
  }
</div>
